import { OepaUserAccount } from "@ohioepa/oepa-common-lib";

export const extLiveReloadAccount: OepaUserAccount = {
    loginName: 'sw-user',
    accountID: 'sw-user',
    firstName: 'Pelayo',
    lastName: 'Montoto',
    primaryEMailAddress: 'pelayo.montoto@epa.ohio.gov',
    type: 'E_BUSINESS_CENTER',
    roleList: [
      {
        name: 'DSWSWIMSSystemAdmin',
        description: 'SWIMS Admin',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      },
      {
        name: 'DSWHSTSHealthDeptUser',
        description: 'SWIMD Health Department User',
        privilegeList: [
          { type: 'NO_TYPE', name: 'create' },
          { type: 'NO_TYPE', name: 'update' },
        ]
      },
    ]
  }